import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Slider from 'antd/lib/slider';
import InputNumber from 'antd/lib/input-number';
import accounting from 'accounting';
import './PricingCalculator.css';
import { getBudgetValue } from '../../shared/helpers';

class PricingCalculator extends Component {
  componentDidMount() {
    const { onPricingCalculatorMounted } = this.props;
    onPricingCalculatorMounted();
  }

  render() {
    const {
      budget,
      minBudget,
      maxBudget,
      recommendedBudget,
      onBudgetChange,
    } = this.props;

    const lowBudgetDescription = (
      <div>
        <span className="pricing-calculator__description--blue">
          A great value
        </span>{' '}
        Anything lower and we
        <br />
        wouldn&apos;t be able to maintain such strong
        <br />
        talent and projects would suffer.
        <br />
        <br />
        Most of our talent will be incented to take
        <br />
        on your project.
      </div>
    );

    const midBudgetDescription = (
      <div>
        <span className="pricing-calculator__description--blue">
          The sweet spot
        </span>{' '}
        A great video at a<br />
        reasonable price.
        <br />
        <br />
        At this price, all our creators will be fully
        <br />
        incented to take on your project
      </div>
    );

    const highBudgetDescription = (
      <div>
        <span className="pricing-calculator__description--blue">
          We&apos;ve got your back.
        </span>{' '}
        We feel strongly
        <br />
        your video shouldn&apos;t cost more than
        <br />
        this given industry standards.
      </div>
    );

    const getBudgetDescription = () => {
      const budgetPercentage = (budget / maxBudget) * 100;
      if (budgetPercentage < 33) {
        return lowBudgetDescription;
      }
      if (budgetPercentage >= 33 && budgetPercentage <= 64) {
        return midBudgetDescription;
      }
      return highBudgetDescription;
    };

    const budgetValue = getBudgetValue(budget, recommendedBudget);

    return (
      <div className="pricing-calculator">
        <div className="pricing-calculator__description-container">
          {getBudgetDescription()}
        </div>
        <div className="pricing-calculator__recommended-price-container">
          <div className="pricing-calculator__recommended-price--label">
            Recommended
          </div>
          <div className="pricing-calculator__recommended-price--value">
            ${accounting.format(recommendedBudget)}
          </div>
        </div>
        <div className="pricing-calculator__selected-price-container">
          <div className="pricing-calculator__selected-price--label">
            Price Selected
          </div>
          <InputNumber
            className="pricing-calculator__selected-price--value"
            min={minBudget}
            max={maxBudget}
            formatter={value =>
              `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
            parser={value => value.replace(/\$\s?|(,*)/g, '')}
            value={budgetValue}
            onChange={onBudgetChange}
          />
        </div>
        <div className="pricing-calculator__footer-container">
          <Slider
            className="pricing-calculator__footer-slider"
            min={minBudget}
            max={maxBudget}
            tipFormatter={null}
            onChange={onBudgetChange}
            value={budgetValue}
          />
          <div className="pricing-calculator__footer-slider-description">
            <span>Low Budget</span>
            <span>Mid Budget</span>
            <span>High Budget</span>
          </div>
          <div className="pricing-calculator__footer-description">
            Includes 3-4 revisions + full access to our talent + satisfaction
            guarantee!
          </div>
        </div>
      </div>
    );
  }
}

PricingCalculator.propTypes = {
  budget: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  minBudget: PropTypes.number,
  maxBudget: PropTypes.number,
  recommendedBudget: PropTypes.number,
  onBudgetChange: PropTypes.func,
  onPricingCalculatorMounted: PropTypes.func,
};

export { PricingCalculator };



// WEBPACK FOOTER //
// ./src/components/PricingCalculator/PricingCalculator.js